// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wZBq","type":"styles_type__plWoy","choices":"styles_choices__1wGn2"};